import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dropdowns: {},
};

const dropdownSlice = createSlice({
  name: 'dropdown',
  initialState,
  reducers: {
    setSelectedValue(state, action) {
      const { id, value } = action.payload;
      state.dropdowns[id] = value;
    },
  },
});

export const { setSelectedValue } = dropdownSlice.actions;

export default dropdownSlice.reducer;